import type { TextFieldElementProps } from 'react-hook-form-mui';

import { useAppTranslations } from '@treneo/shared/i18n';

import { TextField } from './text-form-field';

type Props = TextFieldElementProps & {
  name: string;
  label?: string;
};

export const PasswordField = ({ name, label, ...props }: Readonly<Props>) => {
  const { t } = useAppTranslations();

  return (
    <TextField
      {...props}
      type='password'
      name={name}
      label={label ?? t('auth.password')}
      isRequired
    />
  );
};
